{
	"detectingFaces": "Detecting faces...",
	"eyeBarelyOpen": "Barely Open",
	"eyeBlinked": "Blinked",
	"eyeClosed": "Closed",
	"eyeFullyOpen": "Fully Open",
	"eyeIntimatePose": "Intimate Pose",
	"eyeLookingDown": "Looking Down",
	"eyePartiallyOpen": "Partially Open",
	"eyeSmiling": "Smiling",
	"eyeSquinting": "Squinting",
	"eyeSunglasses": "Sunglasses",
	"focusGood": "Good Focus",
	"focusGreat": "Great Focus",
	"focusOutOf": "Out of Focus",
	"focusSoft": "Soft Focus",
	"loadingFaces": "Loading faces...",
	"noFacesDetected": "No faces detected",
	"panelFaceFocus": "Face Focus",
	"panelGtScore": "GT Score",
	"panelScore": "Score",
	"score": "{{title}} Score",
	"score2": "{{var0}}_score",
	"scoreFace": "Face",
	"scoreFocus": "Focus",
	"scoreLighting": "Lighting",
	"tooltipOverallScore": "This is the overall score of the photo rated by AI"
}
